<template>
  <markup-page />
</template>

<script>
import MarkupPage from "./components/markup-page/MarkupPage.vue";
export default {
  name: "App",
  data() {
    return {
      leftDownTab: "layers",
    };
  },
  components: {
    MarkupPage,
  },
  mounted() {
    if (process.env.NODE_ENV == "development") {
      this.basePath = "https://mark-p.inviewlab.com";
      this.debug = true;
    }
  },
};
</script>

<style>
:root {
  box-sizing: border-box;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
}

body {
  margin: 0 0.5em;
  overflow-y: hidden;
  overflow-x: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
*,
::before,
::after {
  box-sizing: inherit;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
}
.mx-1 {
  margin-left: 1em;
  margin-right: 1em;
}
.body {
  background-color: blueviolet;
  overflow-y: hidden;
  overflow-x: hidden;
}
.tool-buttons {
  display: inline-flex;
  margin: 0;
}
.tool-buttons li {
  list-style: none;
}
.tool-button {
  cursor: pointer;
  color: #fff;
  padding: 0.25em 0.5em;
  border-radius: 0.2rem;
  display: inline-block;
  background-color: #6c757d;
  border: 1px solid transparent;
  margin-left: 0.5em;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
}
.main-button {
  background-color: #1b6ec2;
  border-color: #1861ac;
}
.tool-button:disabled {
  background-color: #ccc;
}
.tool-active {
  background-color: #28a745;
}

.hot-keys {
  color: white;
  min-width: 2rem;
}
.hot-keys-legend {
  margin: 0;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 0.2rem;
  display: none;
}
.hot-keys-info {
  margin: 0;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 0.2rem;
  display: block;
  color: white;
}
.hot-keys:hover .hot-keys-legend {
  animation: createBox 0.25s;
  display: block;
  color: white;
  transform-origin: left bottom;
}
.hot-keys:hover .hot-keys-info {
  display: none;
}
@keyframes createBox {
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
}
.img-fade-out {
  animation: fadeout 1s forwards;
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.map-container {
  display: flex;
  height: calc(100vh - 2rem - 2rem);
}
.even-spaced {
  flex: 1 1 0;
  width: 100%;
  overflow: auto;
}
.shrink-spaced {
  flex: 0 1 0;
  width: 100%;
}
.info-container {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin-left: 0.5em;
  flex-wrap: wrap;
  align-items: flex-start;
  min-width: 15em;
  max-width: 20em;
}
.hot-key-legend-item {
  background-color: black;
  border: 1px solid white;
  border-radius: 4px;
  padding: 0 0.15rem;
  margin-left: 0.2rem;
  display: inline-block;
  height: 1.2em;
  color: white;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.doselect {
  -webkit-touch-callout: text; /* iOS Safari */
  -webkit-user-select: text; /* Safari */
  -khtml-user-select: text; /* Konqueror HTML */
  -moz-user-select: text; /* Old versions of Firefox */
  -ms-user-select: text; /* Internet Explorer/Edge */
  user-select: text; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.image-name {
  font-size: 1.25rem;
  color: #212529;
}
a.nav-link {
  white-space: normal;
  text-align: center;
  word-break: break-all;
  color: rgba(0, 0, 0, 0.9);
  display: inline-block;
  font-size: 1.2rem;
  line-height: inherit;
}
a {
  color: #007bff;
  background-color: transparent;
}

a:hover {
  color: #0056b3;
  text-decoration: underline;
}

a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none;
}

a:not([href]):not([tabindex]):hover,
a:not([href]):not([tabindex]):focus {
  color: inherit;
  text-decoration: none;
}

a:not([href]):not([tabindex]):focus {
  outline: 0;
}
.text-centered {
  text-align: center;
}
.move-cursor {
  cursor: move;
}
.crosshair-cursor {
  cursor: crosshair;
}
.rotate-cursor {
  cursor: url("~@/assets/rotate.png") 8 8, auto;
}
.strech {
  width: 100%;
}
.ruler-distance {
  border-color: black;
  background-color: yellow;
}
.grow-btn {
  transition: transform 0.2s linear;
}
.grow-btn:hover {
  transform: scale(1.3);
}
.grow-btn:active {
  transform: scale(1);
}
.shadow-label {
  font-size: 85%;
  background-color: yellow;
  border-color: black;
  padding: 0 0.3em;
  border-radius: 1em;
  border-width: 2px;
  font-weight: bold;
}
.label-cluster {
  max-height: 6.8em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 7em;
  background-color: gray;
  color: white;
  border-color: black;
  padding: 0.2em 0.5em;
  border-radius: 0.5em;
  border-width: 0.2em;
  font-weight: bold;
}
.label-cluster:hover {
  height: auto;
  overflow: auto;
  max-width: initial;
  max-height: initial;
  z-index: 999;
}
.note-shape {
  background-color: transparent;
  border: transparent;
}
.hidden-div {
  visibility: hidden;
}
.overflowable {
  overflow: initial;
}
.left-bottom-tabs {
  list-style: none;
  padding: 0;
  list-style-type: none;
  width: 100%;
  display: flex;
  border-bottom: 2px solid #28a745;
  margin: 0.3rem 0;
}
.tab-item {
  margin-right: 0.2rem;
  background-color: #6c757d;
  padding: 0.1rem 0.3rem;
  border-radius: 0.4rem 0.4rem 0 0;
  cursor: pointer;
  color: white;
  font-size: 88%;
  font-weight: bold;
}
.active-tab {
  background-color: #28a745;
}
.img-fade-out {
  animation: fadeout 1s forwards;
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
